import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'vex-otp-modal',
  templateUrl: './otp-modal.component.html',
  styleUrls: ['./otp-modal.component.scss']
})
export class OtpModalComponent implements OnInit  {

  otp: string = '';
  constructor(private dialogRef: MatDialogRef<OtpModalComponent>) {}

  ngOnInit(): void {
  }
 

  submitOtp() {
    if (this.otp.trim()) {
      this.dialogRef.close(this.otp); // on retourne la valeur OTP au parent
    }
  }

  close() {
    this.dialogRef.close();
  }






}
